import { ChangeEvent, ElementType, MouseEvent, useCallback, useContext } from "react"
import { AppContext } from "@my-helpers/common"
import {
    Box,
    Typography,
    Grid,
    Paper,
    Stack,
    ThemeProvider,
    Avatar,
    IconButton,
    Tooltip,
    Divider
} from "@mui/material";
import { ArrowBack } from '@mui/icons-material';
import { Navigate, useNavigate } from "react-router-dom";
import { Notification } from "@/components/Notification";
import { UserProfile } from "@/components/settings";


const Settings: ElementType = () => {
    const app = useContext(AppContext);
    if (!app) {
        throw new Error('useAppContext must be used within an AppProvider');
    }

    const {
        isLoading,
        error,
        isDarkMode,
        sessionUser,
    } = app.view;

    const { clearError } = app.command;

    const navigate = useNavigate();

    const handleChange = (_event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        //const { name, value } = event.target;
        /*setProfile((prevProfile) => ({
            ...prevProfile,
            [name]: value,
        }));*/
    };

    const handleGoToApp = (event: MouseEvent) => {
        event.preventDefault();
        navigate("/");
    };

    return (
        sessionUser ? (
            <Box sx={{ p: 3 }}>
                <Stack spacing={2} minHeight={'calc(100vh - 64px)'}>
                    <Box
                        display="flex"
                        flexDirection="row"
                        alignItems="center"
                        flexGrow={0}
                        gap={2}
                        justifyContent="space-between"
                    >
                        <Avatar
                            sizes="1.5rem"
                            alt={`${sessionUser?.givenName} ${sessionUser?.familyName}`}
                            sx={{ width: 56, height: 56 }}
                        >
                            {sessionUser?.givenName?.[0]}{sessionUser?.familyName?.[0]}
                        </Avatar>
                        <Typography variant="h4" sx={{ flexGrow: 1 }}>
                            Settings
                        </Typography>
                        <Tooltip title="Back to Helpers" >
                            <IconButton
                                onClick={handleGoToApp}
                                sx={{
                                    color: 'primary.light',
                                    backgroundColor: 'lightGray',
                                    flexShrink: 0,
                                    '&:hover': {
                                        color: 'white',
                                        backgroundColor: 'primary.light',
                                    }
                                }}
                            >
                                <ArrowBack />
                            </IconButton>
                        </Tooltip>
                    </Box>
                    <Divider />
                    <Grid container spacing={4}>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <UserProfile sessionUser={sessionUser} handleChange={handleChange} />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <Paper
                                elevation={3}
                                sx={{
                                    p: 4,
                                    maxWidth: 1200,
                                    margin: 'auto'
                                }}
                            >
                                <Stack spacing={2}>
                                    <Typography variant="h5" sx={{ mb: 2 }}>
                                        Notifications
                                    </Typography>
                                </Stack>
                            </Paper>
                        </Grid>
                        <Grid
                            size={{ xs: 12, sm: 6 }}
                            minHeight={'calc(50vh - 96px)'}
                        >
                            <Paper
                                elevation={3}
                                sx={{
                                    p: 4,
                                    maxWidth: 1200,
                                    margin: 'auto'
                                }}
                            >
                                <Stack spacing={2}>
                                    <Typography variant="h5" sx={{ mb: 2 }}>
                                        Plan
                                    </Typography>
                                </Stack>
                            </Paper>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <Paper
                                elevation={3}
                                sx={{
                                    p: 4,
                                    maxWidth: 1200,
                                    margin: 'auto'
                                }}>
                                <Stack spacing={2}>
                                    <Typography variant="h5" sx={{ mb: 2 }}>
                                        Usage
                                    </Typography>
                                </Stack>
                            </Paper>
                        </Grid>
                        <Notification
                            isLoading={isLoading}
                            error={error}
                            clearError={clearError}
                        />
                    </Grid>
                </Stack>
            </Box>
        ) : (
            <Navigate to="/signin" />
        )
    )
}

export default Settings;